const getHlsVideoId = (src: string) => {
  const result = src.split("/");
  return result[result.length - 1].split(".m3u8")[0];
};

export default getHlsVideoId;
